"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStyles = exports.DocumentCardTitleGlobalClassNames = void 0;
var Styling_1 = require("../../Styling");
var Utilities_1 = require("../../Utilities");
exports.DocumentCardTitleGlobalClassNames = {
    root: 'ms-DocumentCardTitle',
};
var getStyles = function (props) {
    var _a;
    var theme = props.theme, className = props.className, showAsSecondaryTitle = props.showAsSecondaryTitle;
    var palette = theme.palette, fonts = theme.fonts, effects = theme.effects;
    var classNames = (0, Styling_1.getGlobalClassNames)(exports.DocumentCardTitleGlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            showAsSecondaryTitle ? fonts.medium : fonts.large,
            {
                padding: '8px 16px',
                display: 'block',
                overflow: 'hidden',
                position: 'relative',
                wordWrap: 'break-word',
                height: showAsSecondaryTitle ? '45px' : '38px',
                lineHeight: showAsSecondaryTitle ? '18px' : '21px',
                color: showAsSecondaryTitle ? palette.neutralSecondary : palette.neutralPrimary,
                selectors: (_a = {
                        ':focus': {
                            outline: '0px solid',
                        }
                    },
                    _a[".".concat(Utilities_1.IsFocusVisibleClassName, " &:focus")] = (0, Styling_1.getInputFocusStyle)(palette.neutralSecondary, effects.roundedCorner2),
                    _a),
            },
            className,
        ],
    };
};
exports.getStyles = getStyles;
//# sourceMappingURL=DocumentCardTitle.styles.js.map